export type ImagesByStation = Record<string, string[]>;

const stationFromPath = (p: string): string => {
    const base = (p || "").split("/").pop() || "";
    const match = base.match(/^[A-Za-z]+/);
    return match ? match[0].toUpperCase() : "ALTRO";
};

/**
 * Normalizza `lista_path_immagini` verso una mappa stazione -> path immagini.
 * Accetta sia il nuovo formato raggruppato ({BHP: [...], BZP: [...]}) sia il
 * vecchio formato piatto (string[]), raggruppando quest'ultimo per prefisso stazione.
 */
export const normalizeImagesByStation = (
    value: string[] | ImagesByStation | null | undefined
): ImagesByStation => {
    if (!value) {
        return {};
    }

    if (Array.isArray(value)) {
        const grouped: ImagesByStation = {};
        for (const p of value) {
            if (typeof p !== "string" || !p.trim()) {
                continue;
            }
            const code = stationFromPath(p);
            if (!grouped[code]) {
                grouped[code] = [];
            }
            grouped[code].push(p);
        }
        return grouped;
    }

    const grouped: ImagesByStation = {};
    for (const [station, paths] of Object.entries(value)) {
        if (!Array.isArray(paths)) {
            continue;
        }
        const list = paths.filter((x) => typeof x === "string" && x.trim().length > 0);
        if (list.length) {
            grouped[station] = list;
        }
    }
    return grouped;
};

export const stationNames = (byStation: ImagesByStation): string[] => Object.keys(byStation).sort();

export const totalImageCount = (byStation: ImagesByStation): number =>
    Object.values(byStation).reduce((acc, list) => acc + list.length, 0);
